import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useRemediation } from '../../context/RemediationContext';

const { FiAlertTriangle, FiClock, FiCheckCircle, FiTrendingDown, FiUsers, FiZap } = FiIcons;

const RemediationStats = () => {
  const { records, learners } = useRemediation();

  const stats = [
    { label: 'Total Remediations', value: records.length, icon: FiZap, color: 'bg-blue-50 text-blue-600', border: 'border-blue-100' },
    { label: 'Pending / In Progress', value: records.filter(r => r.status === 'Pending' || r.status === 'In Progress').length, icon: FiClock, color: 'bg-amber-50 text-amber-600', border: 'border-amber-100' },
    { label: 'Overdue', value: records.filter(r => r.status === 'Overdue').length, icon: FiAlertTriangle, color: 'bg-red-50 text-red-600', border: 'border-red-100' },
    { label: 'Completed', value: records.filter(r => r.status === 'Completed').length, icon: FiCheckCircle, color: 'bg-emerald-50 text-emerald-600', border: 'border-emerald-100' },
    { label: 'Avg. Risk Score', value: Math.round(learners.reduce((a, b) => a + b.phishingRiskScore, 0) / learners.length), icon: FiTrendingDown, color: 'bg-violet-50 text-violet-600', border: 'border-violet-100' },
    { label: 'High-Risk Learners', value: learners.filter(l => l.phishingRiskScore >= 50).length, icon: FiUsers, color: 'bg-rose-50 text-rose-600', border: 'border-rose-100' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {stats.map(s => (
        <div key={s.label} className={`bg-white rounded-xl border ${s.border} shadow-sm p-4 flex flex-col gap-2`}>
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${s.color}`}>
            <SafeIcon icon={s.icon} className="text-base" />
          </div>
          <div className="text-2xl font-bold text-slate-800">{s.value}</div>
          <div className="text-xs font-medium text-slate-500">{s.label}</div>
        </div>
      ))}
    </div>
  );
};

export default RemediationStats;